/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { GroupBase, OptionProps, components } from 'react-select';
import { Search } from 'src/common/components';
import { RemoteSelect, Select } from 'src/common/components/Select';
import { CampaignProps } from 'src/tcr/types';

import { usePhoneListContext } from '../context';

import { PhoneActions } from './PhoneActions';

const CampaignOption = (props: OptionProps<unknown, boolean, GroupBase<unknown>>): JSX.Element => {
  const campaign: CampaignProps = props.data as CampaignProps;

  return (
    <components.Option {...props}>
      <div>{campaign.campaign_id}</div>
      <div className="text-xs text-gray-2.0">{campaign.description}</div>
    </components.Option>
  );
};

export const PhoneFilter = (): JSX.Element => {
  const { actions, state } = usePhoneListContext();
  const { campaigns, search } = state;
  const { searchByNumber, searchByAccount, searchByCampaign } = actions;

  const handlePhone = (phone: string): void => {
    searchByNumber(phone);
  };

  const handleAccount = (element: unknown): void => {
    searchByAccount(element ? (element as any).value : '');
  };

  const handleCampaign = (element: unknown): void => {
    searchByCampaign(element ? (element as CampaignProps).id : '');
  };

  return (
    <div className="grid grid-cols-4 gap-4 mb-4">
      <div>
        <Search setSearch={handlePhone} placeholder="Phone number" className="sm:w-full" />
      </div>
      <div>
        <RemoteSelect
          url="account_admin?basic_info=true"
          cacheOptions
          placeholder="Account"
          fieldLabel="name"
          fieldId="id"
          onChange={handleAccount}
          isClearable
          dataPath="results"
        />
      </div>
      <div>
        <Select
          placeholder="Campaign"
          options={campaigns}
          fieldLabel="campaign_id"
          fieldId="id"
          components={{ Option: CampaignOption }}
          onChange={handleCampaign}
          value={search.campaign}
          isClearable
        />
      </div>
      <div className="flex justify-end">
        <PhoneActions />
      </div>
    </div>
  );
};
